import React from 'react';
import Box from '@mui/material/Box';
import { azure, emerald } from '../theme';

// DynaCloud logogram (from the original brand SVG) recoloured with a live
// azure→emerald gradient so it reads on the dark canvas, plus a text
// wordmark that stays crisp at any size and in both directions.
const LOGOGRAM_PATH =
  'M9.00537 3.67782C7.57471 4.67818 6.28101 5.86093 5.15796 7.19235C9.74726 6.76628 15.5778 7.462 22.347 10.8466C29.5756 14.4608 35.3964 14.583 39.4474 13.8016C39.0798 12.6887 38.617 11.6191 38.0689 10.6023C33.4316 11.0914 27.4866 10.444 20.5582 6.97993C16.1586 4.78013 12.2804 3.87396 9.00537 3.67782ZM35.36 6.7466C31.6979 2.65495 26.376 0.0799561 20.4526 0.0799561C18.7131 0.0799561 17.0253 0.302063 15.4163 0.719436C17.5955 1.31404 19.9105 2.18394 22.347 3.40222C27.4196 5.93848 31.799 6.75511 35.36 6.7466ZM40.3135 17.708C35.4195 18.6744 28.6614 18.4759 20.5582 14.4243C12.9826 10.6365 6.95307 10.6842 2.88654 11.5879C2.67664 11.6345 2.47168 11.6835 2.27167 11.7345C1.73926 12.8924 1.31427 14.11 1.00934 15.3744C1.33502 15.2874 1.67157 15.2047 2.0188 15.1275C6.95221 14.0312 13.9227 14.0788 22.347 18.291C29.9227 22.0788 35.9522 22.0311 40.0188 21.1274C40.1581 21.0965 40.2954 21.0645 40.4304 21.0315C40.4452 20.7162 40.4526 20.3989 40.4526 20.0799C40.4526 19.2774 40.4054 18.4859 40.3135 17.708ZM39.7774 25.2522C34.9309 26.0995 28.3696 25.7743 20.5582 21.8687C12.9826 18.0809 6.95307 18.1286 2.88654 19.0323C1.98389 19.2328 1.17188 19.4771 0.455567 19.735C0.453614 19.8497 0.452637 19.9647 0.452637 20.0799C0.452637 31.1256 9.40693 40.0799 20.4526 40.0799C29.7097 40.0799 37.4979 33.7908 39.7774 25.2522Z';

export default function Logo({ size = 34, withWordmark = true, sx }) {
  const gradId = React.useId();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.25,
        lineHeight: 1,
        userSelect: 'none',
        ...sx,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 41 41"
        role="img"
        aria-label="DynaCloud"
        style={{ flex: 'none', display: 'block' }}
      >
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={azure[300]} />
            <stop offset="55%" stopColor={azure[400]} />
            <stop offset="100%" stopColor={emerald[400]} />
          </linearGradient>
        </defs>
        <path d={LOGOGRAM_PATH} fill={`url(#${gradId})`} fillRule="evenodd" clipRule="evenodd" />
      </svg>
      {withWordmark && (
        <Box
          component="span"
          dir="ltr"
          sx={{
            fontFamily: '"Manrope","Segoe UI",system-ui,sans-serif',
            fontSize: size * 0.62,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            color: 'text.primary',
            whiteSpace: 'nowrap',
          }}
        >
          Dyna
          <Box component="span" sx={{ fontWeight: 400, color: 'text.secondary' }}>
            Cloud
          </Box>
        </Box>
      )}
    </Box>
  );
}
